export const truncateString = (
  text: string | null | undefined,
  maxLength: number,
): string => {
  if (text === null || text === undefined || text.length <= maxLength) {
    return text || '';
  }
  return text.substring(0, maxLength) + '...';
};
